import { Icon } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import actions from '../../actions';
import config from '../../config';
import { messageSelector } from '../../selectors/selector';
import fileIcon from '../../static/images/file.png';
import { computeMessage, CUSTOM_MESSAGE_TYPE } from '../common/MessageProcessing';
import { createTimeoutMessage } from '../common/TimeoutMessage';

export const TimestampStyle = styled.div`
    flex: 0;
    margin-bottom: 12px;
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
    line-height: 22px;
    text-align: center;
`;

const MessageLine = styled.div`
    display: flex;
    width: calc(100% - 36px);
    margin: 0 18px 12px;
    flex-direction: row;
    flex-flow: ${props => {
        const { flow = undefined } = props.messageData;
        if (flow === 'out') {
            return 'row-reverse';
        } else if (flow === 'in') {
            return 'row';
        } else {
            return 'initial';
        }
    }};
`;
const AvatarStyle = styled.div`
    flex: 0 0 auto;
    height: 44px;
    width: 44px;
    background: transparent url(${props => props.messageData.avatar || ''}) no-repeat center;
    background-size: cover;
    border-radius: 2px;
`;

const before = `&::before{
    content: '';
    display: block;
    border: 8px solid transparent;
    border-right:8px solid rgba(255,255,255,1);
    position: absolute;
    top: 15px;
    left: -16px;
};`;

const after = `&::before{
    content: '';
    display: block;
    border: 8px solid transparent;
    border-left:8px solid rgba(155,227,168,1);
    position: absolute;
    top: 15px;
    right: -16px;
};`;

const MessageBodyStyle = styled.div`
    flex: 0 0 auto;
    margin: 0 10px;
    padding: 12px;
    max-width: 170px;
    background: ${props => {
        const { messageData } = props;
        if (messageData.flow === 'out') {
            return 'rgba(155,227,168,1)';
        } else if (messageData.flow === 'in') {
            return 'rgba(255,255,255,1)';
        } else {
            return '#FFF';
        }
    }};
    border-radius: 8px;
    white-space: normal;
    word-break: break-all;
    position: relative;
    ${props => {
        const { messageData } = props;
        if (messageData.flow === 'out') {
            return after;
        } else if (messageData.flow === 'in') {
            return before;
        }
    }}
`;

const ImageMessage = styled.img`
    width: 100px;
`;

const FileIcon = styled.div`
    width: 46px;
    height: 46px;
    background: rgba(45, 128, 241, 0.8);
    border-radius: 6px;
    padding: 10px;

    img {
        width: 26px;
        height: 24px;
    }
`;
const WordIcon = styled.span`
    width: 23px;
    height: 33px;
    font-size: 24px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 27px;
`;
const FileInfo = styled.div`
    margin: 0 0 0 6px;

    .file-info-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
        margin: 0 0 6px 0;
    }

    .file-info-size {
        height: 20px;
        font-size: 12px;
        color: rgba(102, 102, 102, 1);
        line-height: 22px;
    }
`;

function Avatar(props) {
    const { messageData } = props;
    let user;
    if (messageData.avatar) {
        user = <AvatarStyle messageData={messageData} />;
    } else if (messageData.type !== 'notification') {
        user = (
            <p>
                <em>{messageData.showTime}</em>
                {messageData.from}
            </p>
        );
    }
    return user;
}

/**
 * @return {null}
 */
function Message(props) {
    const {
        messageData: rawMessage,
        type,
        userUID,
        userInfos,
        myInfo,
        isHistory,
        customerServiceAccount,
        fnShowImageDialog,
        setImg,
    } = props;
    const messageData = computeMessage(
        rawMessage,
        type,
        userUID,
        userInfos,
        myInfo,
        isHistory,
        customerServiceAccount
    );

    if (!messageData) {
        console.error(`Message data parse failed.`);
        return null;
    }

    if (messageData.type === 'timeTag') {
        return <TimestampStyle>{messageData.showText}</TimestampStyle>;
    } else if (messageData.type === 'tip') {
        return <div>{messageData.showText}</div>;
    } else if (messageData.type === 'notification' && messageData.scene === 'team') {
        return <div>{messageData.showText}</div>;
    } else if (messageData.type === CUSTOM_MESSAGE_TYPE.TIMEOUT) {
        // 自定义消息类型
        return (
            <MessageLine messageData={messageData}>{createTimeoutMessage(props, messageData)}</MessageLine>
        );
    } else if (messageData.flow === 'in' || messageData.flow === 'out') {
        let content;
        if (messageData.type === 'text') {
            // content = messageData.showText
            const regExp = /(http|https):\/\/[^\s]*/g;
            content = messageData.showText
                .replace(/\n/g, `<br/>`)
                .replace(regExp, match => `<a href='${match}' target='_blank'>${match}</a>`);
        } else if (messageData.type === 'image') {
            content = (
                <ImageMessage
                    src={messageData.originLink}
                    alt=""
                    onClick={() => {
                        setImg(messageData.originLink);
                        fnShowImageDialog(true);
                        // window.open(messageData.originLink, '_blank')
                    }}
                />
            );
        } else if (messageData.type === 'file') {
            let nameUrl = window.nim.packFileDownloadName({
                url: messageData.fileLink,
                name: messageData.file.name,
            });

            content = (
                <React.Fragment>
                    <a
                        style={{ display: 'flex' }}
                        href={nameUrl}
                        target="_blank"
                        title={messageData.showText}
                    >
                        <FileIcon>
                            {/(doc|docx)/i.test(messageData.file.ext) ? (
                                <WordIcon>W</WordIcon>
                            ) : (
                                <img src={fileIcon} alt="" />
                            )}
                        </FileIcon>
                        <FileInfo>
                            <div className="file-info-name">{messageData.showText}</div>
                            <div className="file-info-size">{`${parseInt(
                                messageData.file.size / 1024
                            )}KB`}</div>
                        </FileInfo>
                    </a>
                </React.Fragment>
            );
        } else if (messageData.type === 'notification') {
            content = messageData.showText;
        } else {
            console.error(`Unsupported message type: ${JSON.stringify(messageData)}`);
            return null;
        }

        return (
            <MessageLine messageData={messageData}>
                <Avatar messageData={messageData} />
                {messageData.type === 'text' ? (
                    <MessageBodyStyle
                        messageData={messageData}
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                ) : (
                    <MessageBodyStyle messageData={messageData}>{content}</MessageBodyStyle>
                )}
                {messageData.status === 'fail' ? (
                    <span className="msg-failed">
                        <Icon type="warning" />
                    </span>
                ) : null}
            </MessageLine>
        );
    } else {
        console.error(`Unsupported message type: ${JSON.stringify(messageData)}`);
        return null;
    }
}

export const ConnectedMessage = connect(
    (state, props) => {
        const { imStore, customerServiceAccount, showImageDialog } = state[config.reduxStoreName];
        const { userUID, myInfo, userInfos } = imStore;
        return {
            customerServiceAccount,
            userUID: userUID,
            userInfos: userInfos,
            myInfo: myInfo,
            messageData: messageSelector(state, props),
            showImageDialog,
        };
    },
    {
        createSession: actions.createSession,
        resetSession: actions.resetCurrSession,
        fnShowImageDialog: actions.showImageDialog,
        setImg: actions.setImg,
    }
)(Message);
